import { jsx as _jsx } from "react/jsx-runtime";
const TrashIcon = (props) => {
    return (_jsx("svg", Object.assign({ width: "100%", height: "100%", viewBox: "0 0 14 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: _jsx("path", { d: "M4.50065 0.5V1.33333H0.333984V3H1.16732V13.8333C1.16732 14.2754 1.34291 14.6993 1.65547 15.0118C1.96803 15.3244 2.39196 15.5 2.83398 15.5H11.1673C11.6093 15.5 12.0333 15.3244 12.3458 15.0118C12.6584 14.6993 12.834 14.2754 12.834 13.8333V3H13.6673V1.33333H9.50065V0.5H4.50065ZM2.83398 3H11.1673V13.8333H2.83398V3ZM4.50065 4.66667V12.1667H6.16732V4.66667H4.50065ZM7.83398 4.66667V12.1667H9.50065V4.66667H7.83398Z", fill: props.color }) })));
};
TrashIcon.defaultProps = {
    color: 'white',
};
export default TrashIcon;
